import { render, staticRenderFns } from "./teacherAvailability.vue?vue&type=template&id=2ffa2262&"
import script from "./teacherAvailability.vue?vue&type=script&lang=js&"
export * from "./teacherAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports